import type { AdminUserStatus } from "@/app/_services/RbacService";

export const STATUS_LABELS: Record<AdminUserStatus, string> = {
  pending: "Invited",
  active: "Active",
  suspended: "Suspended",
};

export const STATUS_BADGE_CLASSES: Record<AdminUserStatus, string> = {
  pending: "border-amber-200 bg-amber-50 text-amber-700",
  active: "border-emerald-200 bg-emerald-50 text-emerald-700",
  suspended: "border-red-200 bg-red-50 text-red-700",
};

export const STATUS_DOT_CLASSES: Record<AdminUserStatus, string> = {
  pending: "bg-amber-500",
  active: "bg-emerald-500",
  suspended: "bg-red-500",
};
